/**
 * Hier kommt Code für das Zeitkonto bzw. EGFZ Geschichten hin
 * - Gutzeitkonto
 * - Urlaubskonto
 * - Mutterschutz
 * - Krank
 */

import _ from 'underscore';
import dayjs from '../../../../shared/services/dayjs.js';
import { validateZeitkonto } from './ma_daten.js';
import stammdatenService from '../services/stammdatenService.js';
import {
    checkUrlaubsantragKollisionen,
    collectValues,
    convertNumberToEuro,
    debounce,
    displayArray,
    displayValues,
    erstelleMitarbeiterListe,
    formatNumber2Decimals
} from '../util.js';
import {
    MutterschaftsgeldKalendertag,
    MutterschutzKalendertageMonat,
    SchutzfristNachEntbindungBesondereWochen,
    SchutzfristNachEntbindungWochen,
    SchutzfristVorEntbindungWochen
} from '../../../../../domain/konstanten/Mutterschutz.js';
import systemNachrichtService from '../services/systemNachrichtService.js';
import SystemDialogService from '../../../../shared/services/systemDialogService.js';
import schichtService from '../services/schichtService.js';
import { getUrlaub, getUrlaubListe, getSonderurlaubSumme, getUrlaubAktuellesJahr } from '../../../../../common/functions/urlaubHelper.js';

window.myHandlers = window.myHandlers || {};
window.myVars = window.myVars || {};
window.myHandlers.speichereUrlaubskonto = speichereUrlaubskonto;
window.myHandlers.updateUrlaubsantrag = updateUrlaubsantrag;
window.myHandlers.updateUrlaubZusatz = updateUrlaubZusatz;
window.myHandlers.updateUrlaubVorwert = updateUrlaubVorwert;
window.myHandlers.updateGutzeitVorwert = updateGutzeitVorwert;
window.myHandlers.updateGutzeitAbgegolten = updateGutzeitAbgegolten;
window.myHandlers.erstelleEntbindungstermin = erstelleEntbindungstermin;
window.myHandlers.bearbeiteEntbindungstermin = bearbeiteEntbindungstermin;
window.myHandlers.confirmEntbindungsdialog = confirmEntbindungsdialog;
window.myHandlers.entferneEntbindungstermin = entferneEntbindungstermin;
window.myHandlers.toggleEntbindungBerufsverbot = toggleEntbindungBerufsverbot;
window.myHandlers.toggleEntbindungFaktorBerechnung = toggleEntbindungFaktorBerechnung;
window.myHandlers.zeigeEntbindungNettoBerechnung = zeigeEntbindungNettoBerechnung;
window.myHandlers.setzeEntbindungZeitraum = setzeEntbindungZeitraum;
window.myHandlers.filterUrlaubsantraege = filterUrlaubsantraege;
window.myHandlers.wechsleUrlaubsjahr = wechsleUrlaubsjahr;
window.myHandlers.addSonderurlaub = addSonderurlaub;
window.myHandlers.updateSonderurlaub = updateSonderurlaub;
window.myHandlers.removeSonderurlaub = removeSonderurlaub;

/**
 * Gibt den aktuell im Urlaubskonto ausgewählten Urlaubseintrag zurück (gewähltes Jahr,
 * Fallback auf das aktuellste Jahr bzw. altes Objektformat).
 * @param {object} aktuelleBeschaeftigung
 * @returns {object}
 */
function getAusgewaehlterUrlaub(aktuelleBeschaeftigung) {
    return getUrlaub(aktuelleBeschaeftigung, window.myVars.ausgewaehltesUrlaubsjahr);
}

// Speichert die Mitarbeiterdaten verzögert (Debounce), damit beim Tippen im Sonderurlaub nicht bei jedem Zeichen gespeichert wird.
const debounceSpeichereMitarbeiter = debounce(async (args) => {
    await stammdatenService.updateMitarbeiterdaten(args[0]);
});

async function ladeZeitkonto(aktuellerMA) {
    if (!_.isEmpty(aktuellerMA)) {
        const journalKomplett = await stammdatenService.leseJournalHistorieMitarbeiter(aktuellerMA._id);
        // aufsteigend sortieren...
        journalKomplett.sort((a, b) => a.Zeitraum.localeCompare(b.Zeitraum));
        // Lade Urlaubsdaten
        ladeUrlaubskonto(aktuellerMA);
        // Lade Gutzeitkonto
        ladeGutzeitkonto(aktuellerMA, journalKomplett);
        // Lade Kranktage Konto
        ladeKranktagekonto(journalKomplett);
        // Lade urzarbeit Konto
        ladeKurzfristigKonto(journalKomplett);
        // Lade urlaubs Konto
        ladeUrlaubstagekonto(journalKomplett);
        // Lade Mutterschutz
        ladeMutterschutz(aktuellerMA);
    }
}

/**
 * Ladet die Urlaubswerte und -anträge in die Oberfläche.
 * Setzt das anzuzeigende Urlaubsjahr standardmäßig auf das Jahr des aktuellen Zeitraums
 * (z.B. nach einem Monatswechsel), sonst auf das aktuellste vorhandene Jahr.
 * @param {object} aktuellerMA
 */
function ladeUrlaubskonto(aktuellerMA) {
    const aktuelleBeschaeftigung = aktuellerMA.Beschaeftigung[0];
    const jahre = getUrlaubListe(aktuelleBeschaeftigung).map((u) => u.UrlaubJahr);
    const zeitraumJahr = parseInt(window.myVars.aktuellesMonatsDatum.format('YYYY'), 10);
    window.myVars.ausgewaehltesUrlaubsjahr = jahre.includes(zeitraumJahr) ? zeitraumJahr : jahre[0];
    zeigeUrlaubskonto(aktuellerMA);
}

/**
 * Zeigt das aktuell gewählte Urlaubsjahr an (ohne den Default neu zu bestimmen),
 * damit eine manuelle Jahresauswahl im Dropdown erhalten bleibt.
 * @param {object} aktuellerMA
 */
function zeigeUrlaubskonto(aktuellerMA) {
    const zeitkontoHTML = document.getElementById('ma-Urlaubskonto');
    const aktuelleBeschaeftigung = aktuellerMA.Beschaeftigung[0];
    const jahre = getUrlaubListe(aktuelleBeschaeftigung).map((u) => u.UrlaubJahr);
    // Falls das gewählte Jahr beim Mitarbeiter nicht (mehr) existiert: aktuellstes Jahr nehmen.
    if (!jahre.includes(window.myVars.ausgewaehltesUrlaubsjahr)) {
        window.myVars.ausgewaehltesUrlaubsjahr = jahre[0];
    }
    befuelleUrlaubsjahrAuswahl(zeitkontoHTML, jahre);
    const urlaub = getAusgewaehlterUrlaub(aktuelleBeschaeftigung);
    displayValues(urlaub, '', zeitkontoHTML, 'ma-');
    zeigeUrlaubsrundungHinweis(urlaub);
    ladeSonderurlaub(urlaub);
    validateZeitkonto(aktuellerMA);
    const urlaubsantraege = aktuelleBeschaeftigung.Urlaubsantraege;
    const antragHTML = document.getElementById('ma-Urlaubsantrag');
    const aktuellesJahr = window.myVars.aktuellesMonatsDatum.format('YYYY');
    const urlaubsantraege1Jahr = urlaubsantraege.filter((ua) => ua.UrlaubVon.substring(0, 4) >= aktuellesJahr || ua.UrlaubBis.substring(0, 4) >= aktuellesJahr);
    displayArray(urlaubsantraege1Jahr, 'ma-ua-', antragHTML);
}

/**
 * Befüllt die Urlaubsjahr-Auswahl mit den vorhandenen Jahren.
 * @param {HTMLElement} zeitkontoHTML
 * @param {number[]} jahre absteigend sortierte Urlaubsjahre
 */
function befuelleUrlaubsjahrAuswahl(zeitkontoHTML, jahre) {
    const select = zeitkontoHTML.querySelector('[aria-label="ma-UrlaubJahrAuswahl"]');
    if (!select) {
        return;
    }
    select.innerHTML = '';
    jahre.forEach((jahr) => {
        const option = document.createElement('option');
        option.value = jahr;
        option.textContent = jahr;
        option.selected = jahr === window.myVars.ausgewaehltesUrlaubsjahr;
        select.appendChild(option);
    });
}

/**
 * Wechselt das angezeigte Urlaubsjahr und lädt das Urlaubskonto neu.
 * @param {HTMLSelectElement} thisElement
 */
function wechsleUrlaubsjahr(thisElement) {
    window.myVars.ausgewaehltesUrlaubsjahr = parseInt(thisElement.value, 10);
    zeigeUrlaubskonto(stammdatenService.aktuellerMitarbeiter);
}

/**
 * Rendert die Sonderurlaub-Einträge ({ SonderurlaubTage, Notiz }) des gewählten Jahres.
 * @param {object} urlaub Urlaubseintrag des gewählten Jahres
 */
function ladeSonderurlaub(urlaub) {
    const liste = document.getElementById('ma-Sonderurlaub-liste');
    const template = document.querySelector('[ma-sonderurlaub-template]');
    if (!liste || !template) {
        return;
    }
    liste.innerHTML = '';
    const sonderurlaube = Array.isArray(urlaub.Sonderurlaub) ? urlaub.Sonderurlaub : [];
    sonderurlaube.forEach((su, index) => {
        const zeile = template.content.cloneNode(true).children[0];
        zeile.setAttribute('data-index', index);
        zeile.querySelector('[aria-label="ma-su-Tage"]').value = su.SonderurlaubTage ?? 0;
        zeile.querySelector('[aria-label="ma-su-Notiz"]').value = su.Notiz ?? '';
        liste.appendChild(zeile);
    });
}

/**
 * Fügt dem gewählten Urlaubsjahr einen leeren Sonderurlaubseintrag hinzu.
 */
async function addSonderurlaub() {
    const aktuelleBeschaeftigung = stammdatenService.aktuellerMitarbeiter.Beschaeftigung[0];
    const urlaub = getAusgewaehlterUrlaub(aktuelleBeschaeftigung);
    if (!Array.isArray(urlaub.Sonderurlaub)) {
        urlaub.Sonderurlaub = [];
    }
    urlaub.Sonderurlaub.push({ SonderurlaubTage: 1, Notiz: '' });
    // Summe/Resturlaub neu berechnen und speichern, danach die Liste neu rendern.
    await speichereUrlaubskonto();
    ladeSonderurlaub(urlaub);
}

/**
 * Speichert Änderungen an einem Sonderurlaubseintrag.
 * @param {HTMLElement} thisElement geändertes Eingabefeld (Tage oder Notiz)
 */
function updateSonderurlaub(thisElement) {
    const aktuellerMA = stammdatenService.aktuellerMitarbeiter;
    const zeile = thisElement.closest('.ma-sonderurlaub-zeile');
    const index = parseInt(zeile.getAttribute('data-index'), 10);
    const urlaub = getAusgewaehlterUrlaub(aktuellerMA.Beschaeftigung[0]);
    const eintrag = urlaub.Sonderurlaub?.[index];
    if (!eintrag) {
        return;
    }
    let tage = parseFloat(zeile.querySelector('[aria-label="ma-su-Tage"]').value);
    if (Number.isNaN(tage) || tage < 0) {
        tage = 0;
    }
    eintrag.SonderurlaubTage = tage;
    eintrag.Notiz = zeile.querySelector('[aria-label="ma-su-Notiz"]').value;
    // Summe/Resturlaub sofort lokal neu berechnen und anzeigen (ohne die Liste neu zu rendern, damit der Fokus erhalten bleibt)...
    aktualisiereUrlaubssummeAnzeige(aktuellerMA);
    // ...das Speichern wird debounced, damit nicht bei jedem Tastendruck gespeichert wird.
    window.myVars.mitarbeiterEditiert = true;
    debounceSpeichereMitarbeiter(aktuellerMA);
}

/**
 * Entfernt einen Sonderurlaubseintrag aus dem gewählten Urlaubsjahr.
 * @param {HTMLElement} thisElement Lösch-Button der Zeile
 */
async function removeSonderurlaub(thisElement) {
    const zeile = thisElement.closest('.ma-sonderurlaub-zeile');
    const index = parseInt(zeile.getAttribute('data-index'), 10);
    const urlaub = getAusgewaehlterUrlaub(stammdatenService.aktuellerMitarbeiter.Beschaeftigung[0]);
    if (!Array.isArray(urlaub.Sonderurlaub)) {
        return;
    }
    urlaub.Sonderurlaub.splice(index, 1);
    // Summe/Resturlaub neu berechnen und speichern, danach die Liste neu rendern.
    await speichereUrlaubskonto();
    ladeSonderurlaub(urlaub);
}

/**
 * Filtert die Urlaubsanträge nach genehmigt, abgelehnt, offen, oder alle
 * @param {Number} filter 
 */
function filterUrlaubsantraege(filter) {
    const mitarbeiter = stammdatenService.aktuellerMitarbeiter;
    const urlaubsantraege = mitarbeiter.Beschaeftigung[0].Urlaubsantraege;
    const antragHTML = document.getElementById('ma-Urlaubsantrag');
    const aktuellesJahr = window.myVars.aktuellesMonatsDatum.format('YYYY');
    if (filter === 'reset') {
        displayArray(urlaubsantraege.filter((ua) => ua.UrlaubVon.substring(0, 4) >= aktuellesJahr || ua.UrlaubBis.substring(0, 4) >= aktuellesJahr), 'ma-ua-', antragHTML);
        return;
    }
    if (filter) {
        displayArray(urlaubsantraege.filter((ua) => (ua.UrlaubVon.substring(0, 4) >= aktuellesJahr || ua.UrlaubBis.substring(0, 4) >= aktuellesJahr) && ua.UrlaubStatus === filter), 'ma-ua-', antragHTML);
        return;
    }
    displayArray(urlaubsantraege, 'ma-ua-', antragHTML);
    document.querySelector('[aria-label="ma-ResturlaubVorwert"]').disabled = window.myVars.HideMod2;
}

/**
 * Ladet alle Journaldaten des Jahres in denen die Gutzeiten vermerkt sind
 */
async function ladeGutzeitkonto(aktuellerMA, journalKomplett) {
    const vorwertInput = document.querySelector('[aria-label="ma-gz-GutzeitVorwert"]');
    const vorwertValue = aktuellerMA.Beschaeftigung[0]?.GutzeitVorwert ? Math.round(aktuellerMA.Beschaeftigung[0].GutzeitVorwert * 100) / 100 : 0;
    vorwertInput.value = vorwertValue;
    if (window.myVars.HideMod) {
        vorwertInput.disabled = true;
    } else {
        vorwertInput.disabled = false;
    }
    // Wir wollen durch jeden Monat iterieren...
    const jahresAnfang = window.myVars.aktuellesMonatsDatum.startOf('year');
    const journalJahr = journalKomplett.filter((journal) => dayjs(journal.ZeitraumDate).tz().isSame(jahresAnfang, 'year'));
    const gutzeitMonateDiv = document.getElementById('ma-gz-monate');
    gutzeitMonateDiv.innerHTML = '';
    const gutzeitTemplate = document.querySelector('[ma-gz-template]');
    for (let i = 0; i < 12; i++) {
        const journalMonat = journalJahr[i];
        if (journalMonat) {
            // Monat
            const tmpDate = dayjs(journalMonat.ZeitraumDate).tz();
            const zeitraum = tmpDate.format('YYYY/MM');
            const gutzeitMonatHTML = gutzeitTemplate.content.cloneNode(true).children[0];
            gutzeitMonatHTML.id = journalMonat._id;
            gutzeitMonatHTML.setAttribute('aria-label', tmpDate.format('YYYY-MM-DD'));
            gutzeitMonatHTML.querySelector('[aria-label="ma-gz-GutzeitMonat"]').innerText = zeitraum;
            gutzeitMonatHTML.querySelector('[aria-label="ma-gz-GutzeitMinus"]').value = formatNumber2Decimals(journalMonat.Mitarbeiter.Monatswerte.GutzeitMinus);
            gutzeitMonatHTML.querySelector('[aria-label="ma-gz-GutzeitPlus"]').value = formatNumber2Decimals(journalMonat.Mitarbeiter.Monatswerte.GutzeitPlus);
            const gutzeitMonatAbgegolten = stammdatenService.aktuellerMitarbeiter.Beschaeftigung[0].GutzeitAbgegolten.find((gz) => gz.Zeitraum === tmpDate.format('YYYY-MM-DD'));
            const abgegoltenValue = gutzeitMonatAbgegolten ? gutzeitMonatAbgegolten.AbgegoltenStunden : 0;
            gutzeitMonatHTML.querySelector('[aria-label="ma-gz-GutzeitAbgegolten"]').value = Math.round(abgegoltenValue * 100) / 100;
            // wir dürfen das Feld nur öffnen, wenn das Journal nicht abgeschlossen ist, der Monat übereinstimmt mit dem aktuellen Zeitraum und es nur eine aktive Qualifikation gibt!
            const verschiedeneQualis = new Set(aktuellerMA.Beschaeftigung[0].Verguetung.filter((vg) => vg.Verwenden).map((qu) => qu.QualifikationID)).size;
            if (!journalMonat.Abgeschlossen
                    && window.myVars.aktuellesMonatsDatum.format('YYYY-MM-DD') == journalMonat.Zeitraum
                    && verschiedeneQualis === 1
                    && !window.myVars.HideMod) {
                gutzeitMonatHTML.querySelector('[aria-label="ma-gz-GutzeitAbgegolten"]').disabled = false;
            }
            const gzMonat = -journalMonat.Mitarbeiter.Monatswerte.GutzeitMinus + journalMonat.Mitarbeiter.Monatswerte.GutzeitPlus - abgegoltenValue;
            gutzeitMonatHTML.querySelector('[aria-label="ma-gz-GutzeitRest"]').value = formatNumber2Decimals(gzMonat);
            gutzeitMonateDiv.appendChild(gutzeitMonatHTML);
        }
    }
    calcGutzeitSummen(aktuellerMA);
}

function calcGutzeitSummen(aktuellerMA) {
    // Plus
    const gutzeitAufbau = Array.from(document.querySelectorAll('[aria-label="ma-gz-GutzeitPlus"]'));
    const aufbauSumme = gutzeitAufbau.reduce((sum, gz) => sum + parseFloat(gz.value.replace(',', '.')), 0);
    document.querySelector('[aria-label="ma-gz-GutzeitSummePlus"]').innerText = new Intl.NumberFormat('de-DE', { maximumFractionDigits: 2 }).format(aufbauSumme);
    // Minus
    const gutzeitAbbau = Array.from(document.querySelectorAll('[aria-label="ma-gz-GutzeitMinus"]'));
    const abbauSumme = gutzeitAbbau.reduce((sum, gz) => sum + parseFloat(gz.value.replace(',', '.')), 0);
    document.querySelector('[aria-label="ma-gz-GutzeitSummeMinus"]').innerText = new Intl.NumberFormat('de-DE', { maximumFractionDigits: 2 }).format(abbauSumme);
    // Abgegolten
    const gutzeitAbgegolten = Array.from(document.querySelectorAll('[aria-label="ma-gz-GutzeitAbgegolten"]'));
    const abgSumme = gutzeitAbgegolten.reduce((sum, gz) => sum + parseFloat(gz.value), 0);
    document.querySelector('[aria-label="ma-gz-GutzeitSummeAbgegolten"]').innerText = new Intl.NumberFormat('de-DE', { maximumFractionDigits: 2 }).format(abgSumme);
    // Reste
    const gutzeitenReste = Array.from(document.querySelectorAll('[aria-label="ma-gz-GutzeitRest"]'));
    const resteSumme = gutzeitenReste.reduce((sum, gz) => sum + parseFloat(gz.value.replace(',', '.')), 0);
    const vorwert = aktuellerMA.Beschaeftigung[0].GutzeitVorwert;
    document.querySelector('[aria-label="ma-gz-GutzeitSummeRest"]').innerText = new Intl.NumberFormat('de-DE', { maximumFractionDigits: 2 }).format(resteSumme + vorwert);
}

async function updateGutzeitAbgegolten(thisElement, event) {
    const urlaubsMonatHTML = thisElement.parentNode;
    const minus = parseFloat(urlaubsMonatHTML.querySelector('[aria-label="ma-gz-GutzeitMinus"]').innerText.replace(',', '.'));
    const plus = parseFloat(urlaubsMonatHTML.querySelector('[aria-label="ma-gz-GutzeitPlus"]').innerText.replace(',', '.'));
    // wir können maximal die Überstunden abgelten lassen...
    let abgeltenValue = parseFloat(thisElement.value);
    if (Number.isNaN(abgeltenValue) || abgeltenValue < 0) {
        systemNachrichtService.zeigeKleineNachricht('Ungültige Eingabe, bitte Wert > 0!', 0);
        if (thisElement.value.includes('-')) {
            thisElement.value = thisElement.value.replace('-', '');
        }
        return;
    }
    const rest = plus - minus - abgeltenValue;
    urlaubsMonatHTML.querySelector('[aria-label="ma-gz-GutzeitRest"]').innerText = rest;
    calcGutzeitSummen(stammdatenService.aktuellerMitarbeiter);
    const aktuellerMA = stammdatenService.aktuellerMitarbeiter;
    const gutzeitAbgeltung = aktuellerMA.Beschaeftigung[0].GutzeitAbgegolten;
    const zeitraum = thisElement.parentNode.getAttribute('aria-label');
    const abgeltungsmonat = gutzeitAbgeltung.find((gz) => gz.Zeitraum === zeitraum);
    if (abgeltungsmonat) {
        abgeltungsmonat.AbgegoltenStunden = abgeltenValue;
    } else {
        gutzeitAbgeltung.push({ Zeitraum: zeitraum, AbgegoltenStunden: abgeltenValue });
    }
    await stammdatenService.updateMitarbeiterdaten(aktuellerMA);
}

async function updateGutzeitVorwert(thisElement) {
    // Um eine einfache Minuseingabe zu ermöglichen, müssen wir ein Löschen des Inputs erlauben
    if (thisElement.value === '-' || thisElement.value === '') {
        return;
    }
    const aktuellerMA = stammdatenService.aktuellerMitarbeiter;
    let vorwert =  parseFloat(thisElement.value);
    if (Number.isNaN(vorwert)) {
        systemNachrichtService.zeigeKleineNachricht('Gutzeit Vorwert automatisch auf 0 gesetzt!', 0);
        vorwert = 0;
        thisElement.value = 0;
    }
    aktuellerMA.Beschaeftigung[0].GutzeitVorwert = Math.round(vorwert * 100) / 100;
    await stammdatenService.updateMitarbeiterdaten(aktuellerMA);
    calcGutzeitSummen(aktuellerMA);
}

/**
 * Berechnet die Urlaubsansprüche und Summen neu und aktualisiert diese.
 */
/**
 * Berechnet UrlaubsanspruchSumme und ResturlaubLaufendesJahr des gewählten Jahres neu
 * (Sonderurlaub erhöht den Anspruch) und aktualisiert die Anzeige – ohne zu speichern.
 * @param {object} aktuellerMA
 */
function aktualisiereUrlaubssummeAnzeige(aktuellerMA) {
    const aktuelleBeschaeftigung = aktuellerMA.Beschaeftigung[0];
    const urlaub = getAusgewaehlterUrlaub(aktuelleBeschaeftigung);
    urlaub.UrlaubsanspruchSumme = urlaub.UrlaubsanspruchZusatzLaufendesJahr + urlaub.UrlaubsanspruchLaufendesJahr + urlaub.ResturlaubVorwert + getSonderurlaubSumme(urlaub);
    urlaub.ResturlaubLaufendesJahr = urlaub.UrlaubsanspruchSumme - urlaub.UrlaubGenehmigtSumme;
    // Die Übersicht zeigt immer den Resturlaub des laufenden Kalenderjahres (Fallback: aktuellstes Jahr) –
    // egal welches Jahr gerade im Dropdown bearbeitet wird.
    aktuellerMA.Uebersicht.Resturlaub = getUrlaubAktuellesJahr(aktuelleBeschaeftigung, dayjs().tz().year()).ResturlaubLaufendesJahr;
    const urlaubHtml = document.getElementById('ma-Urlaubskonto');
    urlaubHtml.querySelector('[aria-label="ma-UrlaubsanspruchSumme"').value = urlaub.UrlaubsanspruchSumme;
    urlaubHtml.querySelector('[aria-label="ma-ResturlaubLaufendesJahr"').value = urlaub.ResturlaubLaufendesJahr;
    zeigeUrlaubsrundungHinweis(urlaub);
}

/**
 * Zeigt einen Hinweis an, falls die Summe des Urlaubsanspruchs gerundet wurde
 * (UrlaubsanspruchLaufendesJahr und -ZusatzLaufendesJahr sind nur auf 2 Nachkommastellen
 * gerundet, erst die Summe wird per Rundungsmodell auf ganze Tage gerundet).
 * @param {object} urlaub
 */
function zeigeUrlaubsrundungHinweis(urlaub) {
    const ungerundeteSumme = urlaub.UrlaubsanspruchZusatzLaufendesJahr + urlaub.UrlaubsanspruchLaufendesJahr + urlaub.ResturlaubVorwert + getSonderurlaubSumme(urlaub);
    const hinweisHtml = document.querySelector('[aria-label="ma-UrlaubsanspruchSummeHinweis"]');
    if (ungerundeteSumme !== urlaub.UrlaubsanspruchSumme) {
        hinweisHtml.innerHTML = `${formatNumber2Decimals(ungerundeteSumme)} <span class="rundung-zeichen">&asymp;</span>`;
        hinweisHtml.title = `Summe Urlaubsanspruch vor Rundung: ${formatNumber2Decimals(ungerundeteSumme)} Tage`;
        hinweisHtml.style.display = 'flex';
    } else {
        hinweisHtml.innerText = '';
        hinweisHtml.title = '';
        hinweisHtml.style.display = 'none';
    }
}

async function speichereUrlaubskonto() {
    const aktuellerMA = stammdatenService.aktuellerMitarbeiter;
    aktualisiereUrlaubssummeAnzeige(aktuellerMA);
    await stammdatenService.updateMitarbeiterdaten(aktuellerMA);
    // updateMitarbeiterdaten ersetzt aktuellerMitarbeiter durch das im Backend neu berechnete Ergebnis
    // (u.a. UrlaubsanspruchLaufendesJahr / -ZusatzLaufendesJahr). Deshalb für Validierung und Anzeige
    // das aktualisierte Objekt verwenden, nicht die alte Referenz.
    const aktuellerMANeu = stammdatenService.aktuellerMitarbeiter;
    validateZeitkonto(aktuellerMANeu);
    // neue Daten anzeigen...
    const urlaubNeu = getAusgewaehlterUrlaub(aktuellerMANeu.Beschaeftigung[0]);
    displayValues(urlaubNeu, '', document.getElementById('ma-Urlaubskonto'), 'ma-');
    zeigeUrlaubsrundungHinweis(urlaubNeu);
}

/**
 * Updated den UrlaubsanspruchZusatzProJahr und -LaufendesJahr.
 * @param {HTMLElement} thisElement input feld des Urlaub Zusatz pro Jahr
 */
async function updateUrlaubZusatz(thisElement) {
    let urlaubszusatzJahr = parseInt(thisElement.value, 10);
    if (Number.isNaN(urlaubszusatzJahr) || urlaubszusatzJahr < 0) {
        systemNachrichtService.zeigeKleineNachricht('Urlaubsanspruchszusatz automatisch auf 0 gesetzt!', 0);
        thisElement.value = 0;
        urlaubszusatzJahr = 0;
    }
    document.body.querySelector('[aria-label="ma-UrlaubsanspruchZusatzProJahr"]').value = urlaubszusatzJahr;
    getAusgewaehlterUrlaub(stammdatenService.aktuellerMitarbeiter.Beschaeftigung[0]).UrlaubsanspruchZusatzProJahr = urlaubszusatzJahr;
    await speichereUrlaubskonto();
}

/**
 * Updated die Resturlaub Vorwerte
 * @param {HTMLElement} thisElement input feld des Urlaub Vorwerts.
 */
async function updateUrlaubVorwert(thisElement) {
    // Um eine einfache Minuseingabe zu ermöglichen, müssen wir ein Löschen des Inputs erlauben
    if (thisElement.value === '-' || thisElement.value === '') {
        return;
    }
    let resturlaubVorjahr = parseInt(thisElement.value, 10);
    if (Number.isNaN(resturlaubVorjahr)) {
        thisElement.value = 0;
        resturlaubVorjahr = 0;
        systemNachrichtService.zeigeKleineNachricht('Resturlaub automatisch auf 0 gesetzt!', 0);
    }
    const aktuelleBeschaeftigung = stammdatenService.aktuellerMitarbeiter.Beschaeftigung[0];
    const urlaub = getAusgewaehlterUrlaub(aktuelleBeschaeftigung);
    const urlaubVerbleibend = document.querySelector('[aria-label="ma-ResturlaubLaufendesJahr"]');
    const differenz = urlaub.ResturlaubVorwert - resturlaubVorjahr;
    const result = parseInt(urlaubVerbleibend.value, 10) - differenz;
    urlaubVerbleibend.value = result;
    urlaub.ResturlaubVorwert = resturlaubVorjahr;
    await speichereUrlaubskonto();
}

/**
 * Updated den Urlaubsantragsstatus, je nach dem welche Aktion ausgeführt wurde
 * @param {HTMLElement} thisElement Urlaub antrag akzeptieren/ablehnen/reset button
 * @param {string} statusUpdate abgelehnt, offen, genehmigt
 */
async function updateUrlaubsantrag(thisElement, statusUpdate) {
    const urlaubsantragHTML = document.getElementById(`ma-ua-${thisElement.id}`);
    const urlaubStatus = urlaubsantragHTML.querySelector('[aria-label="ma-ua-UrlaubStatus"]');
    if (urlaubStatus.innerText === statusUpdate) {
        systemNachrichtService.zeigeKleineNachricht(`Der Status des Urlaubantrags ist bereits ${statusUpdate}!`);
        return;
    }
    const aktuellerMA = stammdatenService.aktuellerMitarbeiter;
    // Wir suchen den Urlaubsantrag im Mitarbeiter
    const urlaubsantrag = aktuellerMA.Beschaeftigung[0].Urlaubsantraege.find((ua) => ua._id === thisElement.id);
    if (!urlaubsantrag) {
        systemNachrichtService.zeigeKleineNachricht('Urlaubsantrag nicht gefunden!', -1);
        return;
    }
    // Hier müssten vor dem Speichervorgang die Urlaubstage als Schichten ein oder ausgetragen werden...
    if (urlaubsantrag.UrlaubStatus !== 'genehmigt' && statusUpdate === 'genehmigt') {
        const kollisionsIndex = checkUrlaubsantragKollisionen(aktuellerMA, urlaubsantrag.UrlaubVon, urlaubsantrag.UrlaubBis, urlaubsantrag._id);
        if (kollisionsIndex >= 0) {
            await SystemDialogService.instance.displayAsync('zeiten-urlaub-kollision-dialog');
            return;
        }
        await schichtService.erstelleUrlaubAusAntrag(aktuellerMA._id, urlaubsantrag._id, statusUpdate);
        await stammdatenService.holeMitarbeiter(aktuellerMA._id);
        await ladeZeitkonto(stammdatenService.aktuellerMitarbeiter);
        return;
    }
    // Wenn wir einen genehmigten Urlaubseintrag widerrufen (offen oder ablehnen), müssen wir die Urlaubstage austragen.
    if (urlaubsantrag.UrlaubStatus === 'genehmigt' && statusUpdate !== 'genehmigt') {
        await schichtService.entferneUrlaub(aktuellerMA._id, urlaubsantrag._id, statusUpdate);
        await stammdatenService.holeMitarbeiter(aktuellerMA._id);
        await ladeZeitkonto(stammdatenService.aktuellerMitarbeiter);
        return;
    }
    // aktualisiere und speichere urlaubsantragstatus offen/abgelehnt
    urlaubStatus.innerText = statusUpdate;
    urlaubsantrag.UrlaubStatus = statusUpdate;
    await stammdatenService.ablehnenUrlaubsantrag(aktuellerMA._id, urlaubsantrag._id, statusUpdate);
    await stammdatenService.holeMitarbeiter(aktuellerMA._id);
    await erstelleMitarbeiterListe();
}

/**
 * Ladet alle Journaldaten des Jahres in denen die Kranktage vermerkt sind
 */
async function ladeKranktagekonto(journalHistorie) {
    // Wir wollen durch jeden Monat iterieren...
    const jahresAnfang = window.myVars.aktuellesMonatsDatum.startOf('year');
    const journalJahr = journalHistorie.filter((journal) => dayjs(journal.ZeitraumDate).tz().isSame(jahresAnfang, 'year'));
    const kranktageMonateDiv = document.getElementById('ma-kt-monate');
    kranktageMonateDiv.innerHTML = '';
    const kranktageTemplate = document.querySelector('[ma-kt-template]');
    for (let i = 0; i < 12; i++) {
        // Monat
        const journalMonat = journalJahr[i];
        if (journalMonat) {
            const tmpDate = dayjs(journalMonat.ZeitraumDate).tz();    
            const zeitraum = tmpDate.format('YYYY/MM');
            const krankTageMonatHTML = kranktageTemplate.content.cloneNode(true).children[0];
            krankTageMonatHTML.id = journalMonat._id;
            krankTageMonatHTML.querySelector('[aria-label="ma-kt-KranktageMonat"]').innerText = zeitraum;
            displayValues(journalMonat.Mitarbeiter.Monatswerte, '', krankTageMonatHTML, 'ma-kt-');
            kranktageMonateDiv.appendChild(krankTageMonatHTML);
        }
    }
    calcKranktageSummen();
}

function calcKranktageSummen() {
    // Kranktage
    const kranktage = Array.from(document.querySelectorAll('[aria-label="ma-kt-Kranktage"]'));
    const kranktageSum = kranktage.reduce((sum, gz) => sum + parseFloat(gz.innerText), 0);
    document.querySelector('[aria-label="ma-kt-KranktageSumme"]').innerText = kranktageSum;
    // KindKrank
    const kindKrank = Array.from(document.querySelectorAll('[aria-label="ma-kt-KindKrank"]'));
    const kindKrankSum = kindKrank.reduce((sum, gz) => sum + parseFloat(gz.innerText), 0);
    document.querySelector('[aria-label="ma-kt-KindKrankSumme"]').innerText = kindKrankSum;
    // Krank6Wochen
    const krank6Wochen = Array.from(document.querySelectorAll('[aria-label="ma-kt-Krank6Wochen"]'));
    const krank6WochenSum = krank6Wochen.reduce((sum, gz) => sum + parseFloat(gz.innerText), 0);
    document.querySelector('[aria-label="ma-kt-Krank6WochenSumme"]').innerText = krank6WochenSum;
    // UnentschuldigtKrank
    const unentschuldigtKrank = Array.from(document.querySelectorAll('[aria-label="ma-kt-UnentschuldigtKrank"]'));
    const unentschuldigtKrankSum = unentschuldigtKrank.reduce((sum, gz) => sum + parseFloat(gz.innerText), 0);
    document.querySelector('[aria-label="ma-kt-UnentschuldigtKrankSumme"]').innerText = unentschuldigtKrankSum;
    // KrankErste4Wochen (KO)
    const krankErste4Wochen = Array.from(document.querySelectorAll('[aria-label="ma-kt-KO"]'));
    const krankErste4WochenSum = krankErste4Wochen.reduce((sum, gz) => sum + parseFloat(gz.innerText), 0);
    document.querySelector('[aria-label="ma-kt-KOSumme"]').innerText = krankErste4WochenSum;
    // KranktageAlle
    const kranktageAlle = Array.from(document.querySelectorAll('[aria-label="ma-kt-KranktageAlle"]'));
    const kranktageAlleSum = kranktageAlle.reduce((sum, gz) => sum + parseFloat(gz.innerText), 0);
    document.querySelector('[aria-label="ma-kt-KranktageAlleSumme"]').innerText = kranktageAlleSum;
}

/**
 * Ladet alle Journaldaten des Jahres in denen die Kranktage vermerkt sind
 */
async function ladeKurzfristigKonto(journalHistorie) {
    // Wir wollen durch jeden Monat iterieren...
    const jahresAnfang = window.myVars.aktuellesMonatsDatum.startOf('year');
    // Nur kurzfristige Beschäftigung berücksichtigen
    const journalJahr = journalHistorie.filter((journal) => dayjs(journal.ZeitraumDate).tz().isSame(jahresAnfang, 'year') && journal.Mitarbeiter.Beschaeftigung[0].Personengruppenschluessel === '110');
    const kurzarbeitMonateDiv = document.getElementById('ma-kft-monate');
    kurzarbeitMonateDiv.innerHTML = '';
    const kurzfristigTemplate = document.querySelector('[ma-kft-template]');
    let kftSumme = 0;
    for (let i = 0; i < 12; i++) {
        // Monat
        const journalMonat = journalJahr[i];
        if (journalMonat) {
            const tmpDate = dayjs(journalMonat.ZeitraumDate).tz();
            const zeitraum = tmpDate.format('YYYY/MM');
            const KurzfristigTageMonatHTML = kurzfristigTemplate.content.cloneNode(true).children[0];
            KurzfristigTageMonatHTML.id = journalMonat._id;
            KurzfristigTageMonatHTML.querySelector('[aria-label="ma-kft-KurzfristigTageMonat"]').innerText = zeitraum;
            KurzfristigTageMonatHTML.querySelector('[aria-label="ma-kft-KurzfristigTage"]').innerText = journalMonat.Mitarbeiter.Monatswerte.Arbeitstage;
            kftSumme += journalMonat.Mitarbeiter.Monatswerte.Arbeitstage;
            kurzarbeitMonateDiv.appendChild(KurzfristigTageMonatHTML);
        }
    }
    document.querySelector('[aria-label="ma-kft-KurzfristigTageSumme"]').innerText = kftSumme;
}
/**
 * Ladet alle Journaldaten des Jahres in denen die Kranktage vermerkt sind
 */
async function ladeUrlaubstagekonto(journalHistorie) {
    // Wir wollen durch jeden Monat iterieren...
    const jahresAnfang = window.myVars.aktuellesMonatsDatum.startOf('year');
    // Nur kurzfristige Beschäftigung berücksichtigen
    const journalJahr = journalHistorie.filter((journal) => dayjs(journal.ZeitraumDate).tz().isSame(jahresAnfang, 'year'));
    const kurzarbeitMonateDiv = document.getElementById('ma-urlaubstage-monate');
    kurzarbeitMonateDiv.innerHTML = '';
    const kurzfristigTemplate = document.querySelector('[ma-urlaubstage-template]');
    let utSumme = 0;
    for (let i = 0; i < 12; i++) {
        // Monat
        const journalMonat = journalJahr[i];
        if (journalMonat) {
            const tmpDate = dayjs(journalMonat.ZeitraumDate).tz();
            const zeitraum = tmpDate.format('YYYY/MM');
            const KurzfristigTageMonatHTML = kurzfristigTemplate.content.cloneNode(true).children[0];
            KurzfristigTageMonatHTML.id = journalMonat._id;
            KurzfristigTageMonatHTML.querySelector('[aria-label="ma-urlaubstage-UrlaubstageMonat"]').innerText = zeitraum;
            KurzfristigTageMonatHTML.querySelector('[aria-label="ma-urlaubstage-Urlaubstage"]').innerText = journalMonat.Mitarbeiter.Monatswerte.Urlaubstage;
            utSumme += journalMonat.Mitarbeiter.Monatswerte.Urlaubstage;
            kurzarbeitMonateDiv.appendChild(KurzfristigTageMonatHTML);
        }
    }
    document.querySelector('[aria-label="ma-urlaubstage-UrlaubstageSumme"]').innerText = utSumme;
}

const leererEntbindungstermin = {
    Entbindungsdatum: '',
    EntbindungBesondere: false,
    EntbindungBerufsverbot: false,
    EntbindungBerufsverbotVon: '',
    MutterschutzVon: '',
    MutterschutzBis: '',
    FaktorBerechnung: 'automatisch',
    DurchschnittlichesNetto: 0,
};

// Im Bearbeiten-Modus bleibt der Beginn des Mutterschutzes stehen, weil die Schichten davor
// in der Regel schon abgerechnet sind. Nur das Ende wird neu vorbelegt.
let entbindungsdialogBearbeiten = false;

/**
 * Belegt den Mutterschutzzeitraum im Dialog mit der gesetzlichen Schutzfrist vor:
 * 6 Wochen vor der Entbindung, 8 bzw. 12 Wochen (besondere Geburt) danach.
 * Beim Bearbeiten wird nur das Ende neu belegt, der Beginn bleibt unverändert.
 */
function setzeEntbindungZeitraum() {
    const dialog = document.getElementById('entbindungstermin-dialog');
    const entbindungsdatum = dialog.querySelector('[aria-label="ma-entbindung-Entbindungsdatum"]').value;
    if (!entbindungsdatum) return;
    const istBesondere = dialog.querySelector('[aria-label="ma-entbindung-EntbindungBesondere"]').checked;
    const wochenNachEntbindung = istBesondere ? SchutzfristNachEntbindungBesondereWochen : SchutzfristNachEntbindungWochen;
    const entbindung = dayjs.tz(entbindungsdatum, dayjs.tz.DEFAULT_TZ);
    if (!entbindungsdialogBearbeiten) {
        dialog.querySelector('[aria-label="ma-entbindung-MutterschutzVon"]').value = entbindung.subtract(SchutzfristVorEntbindungWochen, 'weeks').format('YYYY-MM-DD');
    }
    dialog.querySelector('[aria-label="ma-entbindung-MutterschutzBis"]').value = entbindung.add(wochenNachEntbindung, 'weeks').format('YYYY-MM-DD');
}

/**
 * Blendet das "ab wann" Datum des Berufsverbots im Entbindungsdialog ein/aus.
 * @param {boolean} hatBerufsverbot
 */
function toggleEntbindungBerufsverbot(hatBerufsverbot) {
    document.getElementById('ma-entbindung-berufsverbot-input').style.display = hatBerufsverbot ? '' : 'none';
}

/**
 * Bei automatischer Ermittlung wird das Durchschnittsnetto erst bei der Abrechnung gebildet,
 * deshalb ist das Eingabefeld dann gesperrt.
 * @param {string} faktorBerechnung 'automatisch' oder 'manuell'
 */
function toggleEntbindungFaktorBerechnung(faktorBerechnung) {
    const istManuell = faktorBerechnung === 'manuell';
    const nettoInput = document.querySelector('[aria-label="ma-entbindung-DurchschnittlichesNetto"]');
    nettoInput.disabled = !istManuell;
    // Nur bei manueller Eingabe ist das Feld ein Pflichtfeld, entsprechend auch nur dann hinterlegt.
    nettoInput.required = istManuell;
    document.getElementById('ma-entbindung-netto-hinweis').style.display = istManuell ? 'none' : '';
}

/**
 * Zeigt im Entbindungsdialog die Herleitung des Mutterschutzlohns pro Kalendertag:
 * Netto/Tag (Monatswert / 30) minus Mutterschaftsgeld der Krankenkasse, niemals unter 0 €.
 */
function zeigeEntbindungNettoBerechnung() {
    const netto = parseFloat(document.querySelector('[aria-label="ma-entbindung-DurchschnittlichesNetto"]').value) || 0;
    const nettoTag = netto / MutterschutzKalendertageMonat;
    const zuschussTag = Math.max(nettoTag - MutterschaftsgeldKalendertag, 0);
    document.getElementById('ma-entbindung-netto-tag').innerText = convertNumberToEuro(nettoTag);
    document.getElementById('ma-entbindung-netto-kasse').innerText = convertNumberToEuro(MutterschaftsgeldKalendertag);
    document.getElementById('ma-entbindung-netto-zuschuss').innerText = convertNumberToEuro(zuschussTag);
}

/**
 * Öffnet den Entbindungsdialog und befüllt ihn mit den Werten des Termins.
 * @param {object} termin bestehender Termin oder leerer Entbindungstermin
 * @param {boolean} istBearbeiten
 */
async function oeffneEntbindungsdialog(termin, istBearbeiten) {
    entbindungsdialogBearbeiten = istBearbeiten;
    const dialog = document.getElementById('entbindungstermin-dialog');
    document.getElementById('entbindungstermin-dialog-header').innerText = istBearbeiten ? 'Entbindungstermin bearbeiten' : 'Neuer Entbindungstermin';
    // Leerer String statt 'block', damit das display: flex der Infobox erhalten bleibt.
    document.getElementById('entbindungstermin-dialog-hinweis-bearbeiten').style.display = istBearbeiten ? '' : 'none';
    displayValues(termin, '', dialog, 'ma-entbindung-');
    toggleEntbindungBerufsverbot(termin.EntbindungBerufsverbot);
    toggleEntbindungFaktorBerechnung(termin.FaktorBerechnung);
    zeigeEntbindungNettoBerechnung();
    return SystemDialogService.instance.displayAsync('entbindungstermin-dialog');
}

async function erstelleEntbindungstermin() {
    const result = await oeffneEntbindungsdialog(leererEntbindungstermin, false);
    if (!result.success) return;
    const erfolg = await stammdatenService.erstelleEntbindungsterminMA(stammdatenService.aktuellerMitarbeiter._id, result.data);
    if (!erfolg) return;
    await ladeZeitkonto(stammdatenService.aktuellerMitarbeiter);
}

async function bearbeiteEntbindungstermin(thisElement) {
    const terminID = thisElement.closest('.ma-mutterschutz-item').id;
    const termin = stammdatenService.aktuellerMitarbeiter.Beschaeftigung[0].Mutterschutz.find((ms) => ms._id === terminID);
    if (_.isEmpty(termin)) {
        systemNachrichtService.zeigeKleineNachricht('Entbindungstermin nicht gefunden!', -1);
        return;
    }
    // Alle Datumsfelder liegen als YYYY-MM-DD String vor, genau wie <input type="date"> sie braucht.
    const terminDialog = { ...leererEntbindungstermin, ..._.pick(termin, _.keys(leererEntbindungstermin)) };
    const result = await oeffneEntbindungsdialog(terminDialog, true);
    if (!result.success) return;
    const erfolg = await stammdatenService.updateEntbindungsterminMA(stammdatenService.aktuellerMitarbeiter._id, terminID, result.data);
    if (!erfolg) return;
    await ladeZeitkonto(stammdatenService.aktuellerMitarbeiter);
}

function confirmEntbindungsdialog() {
    const dialog = document.getElementById('entbindungstermin-dialog');
    const data = { ...leererEntbindungstermin };
    collectValues(data, 'ma-entbindung-', dialog);
    if (!data.Entbindungsdatum) {
        systemNachrichtService.zeigeKleineNachricht('Entbindungstermin muss angegeben werden!');
        return;
    }
    if (!data.MutterschutzVon || !data.MutterschutzBis) {
        systemNachrichtService.zeigeKleineNachricht('Der Zeitraum des Mutterschutzes muss angegeben werden!');
        return;
    }
    // Reine YYYY-MM-DD Strings lassen sich direkt vergleichen.
    if (data.MutterschutzVon >= data.MutterschutzBis) {
        systemNachrichtService.zeigeKleineNachricht('Mutterschutz "von" muss vor "bis" liegen!');
        return;
    }
    if (data.EntbindungBerufsverbot && !(data.EntbindungBerufsverbotVon < data.MutterschutzVon)) {
        systemNachrichtService.zeigeKleineNachricht('Das Beschäftigungsverbot muss vor dem Mutterschutz beginnen!');
        return;
    }
    // 0 € ist ein zulässiger Wert, z.B. wenn das Mutterschaftsgeld der Krankenkasse den Nettolohn
    // schon abdeckt. Abgelehnt werden nur ein leeres Feld (NaN) und negative Beträge.
    if (data.FaktorBerechnung === 'manuell' && !(data.DurchschnittlichesNetto >= 0)) {
        systemNachrichtService.zeigeKleineNachricht('Bitte ein durchschnittliches Netto von 0 € oder mehr angeben!');
        return;
    }
    // Bei automatischer Ermittlung ist das Eingabefeld gesperrt und kann leer sein.
    if (data.FaktorBerechnung !== 'manuell') {
        data.DurchschnittlichesNetto = 0;
    }
    SystemDialogService.instance.confirm(data);
}

function ladeMutterschutz(aktuellerMA) {
    const templateMS = document.body.querySelector('[ma-mutterschutz-template]');
    const listMS = document.getElementById('ma-mutterschutz-list');
    listMS.innerHTML = '';
    const termine = aktuellerMA.Beschaeftigung[0].Mutterschutz;
    document.getElementById('ma-mutterschutz-leer').style.display = _.isEmpty(termine) ? '' : 'none';
    termine.forEach((ms) => {
        const newItem = templateMS.content.cloneNode(true).children[0];
        newItem.id = ms._id;
        displayValues(ms, '', newItem, 'ma-Mutterschutz-');
        newItem.querySelector('[ma-mutterschutz-badge-berufsverbot]').style.display = ms.EntbindungBerufsverbot ? '' : 'none';
        newItem.querySelector('[ma-mutterschutz-badge-besondere]').style.display = ms.EntbindungBesondere ? '' : 'none';
        // Ohne Badges soll die Zeile komplett verschwinden, sonst bleibt der Abstand zur Detailzeile stehen.
        newItem.querySelector('.ma-mutterschutz-badges').style.display = ms.EntbindungBerufsverbot || ms.EntbindungBesondere ? '' : 'none';
        listMS.appendChild(newItem);
    });
}

async function entferneEntbindungstermin(thisElement) {
    const input = await SystemDialogService.instance.displayAsync('entbindungstermin-delete-dialog');
    if (!input.success) return;
    const terminID = thisElement.closest('.ma-mutterschutz-item').id;
    await stammdatenService.entferneEntbindungsterminMA(stammdatenService.aktuellerMitarbeiter._id, terminID);
    ladeMutterschutz(stammdatenService.aktuellerMitarbeiter);
}

export {
    ladeZeitkonto
};
